import * as React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import StyledPopover from '../../../../../common/components/StyledPopover';
import { Modifier } from '../../../../types/Modifier';

type Props = {
  modifier: Modifier;
  anchorEl: HTMLButtonElement | null;
  open: boolean;
  id?: string;
  handleClose: () => void;
};

const ModifierPopupInfo: React.FC<Props> = ({
  modifier,
  anchorEl,
  open,
  id,
  handleClose,
}) => {
  return (
    <StyledPopover
      anchorEl={anchorEl}
      open={open}
      handleClose={handleClose}
      id={id}
      PaperProps={{
        style: {
          width: '350px',
          overflowWrap: 'break-word',
        },
      }}
    >
      <Stack
        spacing={2}
        sx={{
          margin: 2,
        }}
      >
        {modifier.definition && (
          <Box>
            <Typography
              fontFamily={'SFProDisplay-Semibold'}
              color='primary.main'
            >
              Definition
            </Typography>
            <Typography color='text.secondary'>
              {modifier.definition}
            </Typography>
          </Box>
        )}

        {modifier.summary && (
          <Box>
            <Typography
              fontFamily={'SFProDisplay-Semibold'}
              color='primary.main'
            >
              Summary
            </Typography>
            <Typography color='text.secondary'>{modifier.summary}</Typography>
          </Box>
        )}

        {modifier.examples && (
          <Box>
            <Typography
              fontFamily={'SFProDisplay-Semibold'}
              color='primary.main'
            >
              Examples
            </Typography>
            <Typography
              sx={{
                flexWrap: 'wrap',
                display: 'flex',
              }}
              color='text.secondary'
            >
              {modifier.examples}
            </Typography>
          </Box>
        )}

        {modifier.rules && (
          <Box>
            <Typography
              fontFamily={'SFProDisplay-Semibold'}
              color='primary.main'
            >
              Rules
            </Typography>
            <Typography color='text.secondary'>{modifier.rules}</Typography>
          </Box>
        )}
      </Stack>
    </StyledPopover>
  );
};

export default ModifierPopupInfo;
